import React from 'react'
import '../Assets/Css/home.css'
import { Container, Row, Col, Button,Carousel, Card } from 'react-bootstrap';

import Banner1 from '../Assets/Images/banner1.avif';
import Banner2 from '../Assets/Images/banner2.avif';
import Banner3 from '../Assets/Images/banner3.jpg';
import Banner4 from '../Assets/Images/banner4.avif';
import securityabout from '../Assets/Images/securityabout.avif'
import sumanicicon from '../Assets/Images/site-icon.jpg'

import { Helmet } from "react-helmet";
import { FaCertificate, FaBalanceScale, FaUserShield, FaUsers, FaHandshake, FaClock } from 'react-icons/fa';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";

import img1 from "../Assets/Images/team1.jpg";
import img2 from "../Assets/Images/team2.jpg";
import img3 from "../Assets/Images/team10.jpg";
import img4 from "../Assets/Images/team12.jpg";
import img5 from "../Assets/Images/team16.jpg";
import img6 from "../Assets/Images/team3.jpg";
import img7 from "../Assets/Images/team5.jpg";
import img8 from "../Assets/Images/team7.jpg";
import img9 from "../Assets/Images/team15.jpg";
import img10 from "../Assets/Images/team8.jpg";
import img11   from "../Assets/Images/team23.jpg";
import img12 from "../Assets/Images/team6.jpg";
import img13 from"../Assets/Images/team18.jpg";
import img14 from "../Assets/Images/team4.jpg";
import img15 from "../Assets/Images/team9.jpg";


import securityImg from '../Assets/Images/Securityservice.avif';
import bodyguardImg from '../Assets/Images/Personal Bodyguards.avif';
import auditImg from '../Assets/Images/Security Audit.jpg';
import detectiveImg from '../Assets/Images/Private Detective Services.avif';
import enquiryImg from '../Assets/Images/personal.avif';
import economicImg from '../Assets/Images/Economic Investigation.avif';
import cyberImg from '../Assets/Images/Cyber Crime Investigation.avif';
import expertImg from '../Assets/Images/Expert Advice.avif';
import policeImg from '../Assets/Images/Police Department.avif';



export default function HomePage() {
  const carouselData = [
    {
      image: Banner1,
      title: "Welcome to Sumanik Security & Allied Services Pvt. Ltd",
      // description: "Providing professional, well-trained security personnel backed by decades of industry experience.",
    },
    {
      image: Banner2,
      title: "Comprehensive Investigation & Protection Services",
      // description: "From cybercrime to private detective services, we safeguard clients with utmost confidentiality and precision.",
    },
    {
      image: Banner3,
      title: "Certified. Reliable. Government-Approved.",
      // description: "Licensed under PASARA, ESIC, PF & more—your trusted security partner with complete legal compliance.",
    },
    {
      image: Banner4,
      title: "Your Security, Our Commitment",
      // description: "Delivering expert manpower for industrial, corporate, and high-risk environments with integrity and professionalism.",
    },
  ];
  
  
  const services = [
    {
      title: 'Security Services',
      description:
        "Top security solutions with over 30 years of expertise, delivering trained guards across India.",
      indimg: securityImg,
    },
    {
      title: 'Personal Bodyguards',
      description:
        "Professionally trained VIP bodyguards, including ex-Special Forces personnel for elite protection.",
      indimg: bodyguardImg,
    },
    {
      title: 'Security Audit',
      description:
        "Expert-led security audits at industry-leading rates to ensure operational safety and compliance.",
      indimg: auditImg,
    },
    {
      title: 'Private Detective Services',
      description:
        "Trusted detective services for individuals and businesses, including matrimonial and corporate investigations.",
      indimg: detectiveImg,
    },
    {
      title: 'Personal Enquires',
      description:
        "Comprehensive personal investigation services for individuals, celebrities, and organizations.",
      indimg: enquiryImg,
    },
    {
      title: 'Economic Investigation',
      description:
        "Forensic investigations of fraud and corruption using advanced data and technology tools.",
      indimg: economicImg,
    },
    {
      title: 'Cyber Crime Investigation',
      description:
        "Solutions for cyber harassment, data theft, fraud, and other digital threats for all clients.",
      indimg: cyberImg,
    },
    {
      title: 'Expert Advice',
      description:
        "Consulting services for individuals and organizations through email, phone, or face-to-face meetings.",
      indimg: expertImg,
    },
    {
      title: 'Police Department',
      description: "Specialized support services in collaboration with police and enforcement agencies.",
      indimg: policeImg,
    },
    
  ];
  
  
  
  const features = [
    "Private Limited company with all Government Statutory Certificates (PASARA License, PF, ESIC, PT, Shop & Establishment Act 1948)",
    "Legally compliant with fulfillment of all Government and client-directed responsibilities",
    "Team of highly experienced, dedicated, and professionally trained security consultants and administrators",
    "Customized security personnel including guarding force, bouncers, and disciplined staff for high-stress environments",
    "Trusted by banks, consulates, hospitals, hotels, jewelry manufacturers, and government establishments",
    "Over 30 years of experience in the security industry with a nationwide presence"
  ];
  
  
  const images = [
    img1, img2,img12, img13, img3, img4, img5,
    img6, img7, img10,
    img11,  img14, img15, img8, img9
  ];
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  };


 
  
 return (
    <>
    <div className="mainnav min-vh-100 bg-light">
    <Helmet>
      <title>Sumanik Security And Allied Services Pvt Ltd | Your Security, Our Commitment</title>
      <meta name="description" content="Sumanik Security provides reliable, legally compliant security services across India, backed by over 30 years of experience and a highly trained team." />
      <meta name="keywords" content="Security Services Pune, Sumanik Security, Private Security, Bodyguards India, Security Audit, Detective Services, Cyber Crime Investigation" />
      <meta name="author" content="Sumanik Security And Allied Services Pvt Ltd" />
      <meta property="og:title" content="Your Security, Our Commitment | Sumanik Security Pvt Ltd" />
      <meta property="og:description" content="Reliable and customized security solutions from Sumanik Security Pvt Ltd with nationwide presence and 30+ years of expertise." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.sumaniksecurity.com" />
      <meta property="og:image" content="https://www.sumaniksecurity.com/images/og-image.jpg" />
    </Helmet>
   

        {/* Carousel Section */}
      <Carousel fade interval={3000} pause="hover">
        {carouselData.map((item, index) => (
          <Carousel.Item key={index}>
   <img className="d-block w-100 fixed-carousel-image" src={item.image} alt={`Slide ${index + 1}`} />
<Carousel.Caption>
  <div className="container">
    <div className="row  m-0 justify-content-center">
      <div className=" col-8 col-md-6  maindesc">
        <h2 className='text-center'>{item.title}</h2>
      </div>
    </div>
  </div>
</Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>


<section className="py-4 bg-light text-center">
  <div className="container">
    <img src={sumanicicon} alt="Sumanik Icon" style={{ width: '80px' }} className="mb-3" />
    <h2 className="text-uppercase Mainhead">Sumanik Security And Allied Services Pvt Ltd</h2>
    <p className="lead mt-3">
      Located in Wanwadi, Pune, we are a Private Limited company with all Government Statutory Certifications including PASARA License, PF, ESIC, PT, and Shop & Establishment Act 1948 compliance.
      We are committed to fulfilling all legal responsibilities in accordance with Government and client directives.
    </p>
    <p className="mb-3">
      Backed by a highly experienced and professionally trained team of security consultants and administrators, we deliver reliable and customized protection services across India.
    </p>
    <Button  href="/services" className="btn-main">See Our Capabilities</Button>
  </div>
</section>
   

<section className="aboutus-section py-4 bg-white">

  <Container>
  <h2 className="Mainhead mb-3">About Us</h2>
    <Row className="align-items-center ">
      {/* Image Content */}
      <Col lg={5} className="text-center mb-4">
       <div className='aboutimg'>
        <img src={securityabout} alt="About Us" 
        className="img-fluid rounded shadow"
        style={{height:'250px',width:'100%'}}
        />
        </div>
      </Col>
      
      {/* Text Content */}
      <Col lg={7} className="mb-4 ">
       <p className="text-dark" style={{textAlign:'justify'}}>
       We introduce ourselves as <b>Sumanik Security And Allied Services Pvt Ltd</b> located at Wanwadi, Pune City. We are a Private Limited company having all Government
      Statutory Certificates i.e. PASARA License, PF, ESIC, PT, Shop and Est Act 1948 etc. 
      All the legal liabilities and responsibilities shall be fulfilled as per the directions 
      and orders on the subject by Government and the client. Ours is a team of highly 
      experienced, dedicated and professional trained security consultant and administrators
      </p>
      </Col> 
    </Row>
  </Container>
</section>

    
  <section className="industries-section py-4 bg-white">
        <Container>
          <h2  className="Mainhead">Our Services</h2>
          <p className="text-center  mb-5">
         <b> At Sumanik Security And Allied Services Pvt Ltd </b>, Reliable and specialized security & investigation solutions for every need
          </p>
   
<Row className="g-4">
  {services.map((industry, index) => (
    <Col key={index} className="custom-col mb-3">
      <Card className="industry-card h-100  border-0">
      <img src={industry.indimg } alt="" style={{width:'100%',height:'150px',objectFit:'fill'}} />
        <Card.Body> 
          <h6 className="text-center ">{industry.title}</h6>    
          <div className="overlay">
            <h5>{industry.description}</h5> 
          </div>
        </Card.Body>
      </Card>
    </Col>
  ))}

<Col className="custom-col mb-3 d-flex justify-content-center align-items-center">
  <Button
    href="/services"
    className="more-button d-flex align-items-center justify-content-center"
  >
    More <MdKeyboardDoubleArrowRight className="ms-2" />
  </Button>
</Col>
</Row>
        </Container>
   </section>


    <section className="why-choose-aim-section py-4">
      <Container>
        <Row className="text-center mb-4">
          <Col>
            <h2 className="Mainhead">What Sets SUMANIK Apart</h2>
            <p className=" text-dark section-description ">
              Explore the key reasons why AIM stands out in the industry.
            </p>
          </Col>
        </Row>
        <Row className="g-4">
        <Col lg={6} md={6} sm={12}>
  <div className="features-list">
  {features.map((feature, index) => (
  <div className="feature-item d-flex align-items-start mb-3" key={index}>
    <div className="feature-icon me-2 mt-1">
      {index === 0 && <FaCertificate size={20} color="#dcab34" />}  
      {index === 1 && <FaBalanceScale size={20} color="#dcab34" />} 
      {index === 2 && <FaUserShield size={20} color="#dcab34" />}    
      {index === 3 && <FaUsers size={20} color="#dcab34" />}         
      {index === 4 && <FaHandshake size={20} color="#dcab34" />}     
      {index === 5 && <FaClock size={20} color="#dcab34" />}        
    </div>
    <p className="feature-description">{feature}</p>
  </div>
))}
  </div>
</Col>
  <Col lg={6} md={6} sm={12} className="text-center">
    <div className="feature-image">
      <img src={Banner3} alt="Feature" className="img-fluid" />
    </div>
  </Col>
</Row>
      </Container>
    </section>


      {/* Call to Action */}
<section className="cta-section mt-4 text-center py-5">
  <Container>
    <h4 className='mb-4'>
      Looking for professional and reliable security services for your business or personal protection?
    </h4>
    <Button href="/contact" variant="primary">
      Get in Touch
    </Button>
  </Container>
</section>

   <Container className='py-5 mb-4' >
      <Row className='m-0'>
       
        <Col>
        <h2 className="Mainhead">Meet Our Team
        </h2>
          <Slider {...settings}>
            {images.map((img, index) => (
              <div key={index}>
                <img src={img}  alt={`product-${index}`} 
                style={{ width: "100%", height: "auto", padding: "10px",borderRadius:'20px' }} />
              </div>
            ))}
          </Slider>
        </Col>
      </Row>
    </Container>
     
   
      
    </div>
    
    </>
  )
}
